import { useCallback } from 'react'
import ButtonModalSortList, { ItemSortFunction } from '../../../../../../../baseComponents/Sorts/ButtonModalSortList'
import { BaseButtonModalSortListProps } from '../../../../../../../baseComponents/Sorts/ButtonModalSortList/types'
import { twinFetchPostText } from '../../../../../../../utils/globals/data'


interface VariantSortButtonProps extends BaseButtonModalSortListProps { }

const VariantSortButton: React.FC<VariantSortButtonProps> = ({ ...rest }) => {
    const { updateOrder } = useVariantSortButtonLogic()
    return (
        <ButtonModalSortList updateData={updateOrder} getDataFrom='/api/app/product/productVariant/getAllVariantGroups' {...rest} />
    )
}

const useVariantSortButtonLogic = () => {
    const updateOrder: ItemSortFunction = useCallback(async (data) => {
        const resp = await twinFetchPostText('/api/app/product/productVariant/updateVariantGroupsOrder', { variantGroups: data })
        if (resp) {
            return true
        }
        return false
    }, [])

    return { updateOrder }
}

export default VariantSortButton